module.exports = __webpack_public_path__ + "src/assets/img/lessselect.f8d4dae2.png";